import { render, staticRenderFns } from "./LdPagination.vue?vue&type=template&id=59ba5e47&"
import script from "./LdPagination.vue?vue&type=script&lang=js&"
export * from "./LdPagination.vue?vue&type=script&lang=js&"
import style0 from "./LdPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports